'use strict';

import React, {Component, cloneElement} from 'react';
import PropTypes from 'prop-types';
import Slider from 'rc-slider';

const SliderRange = ({handleFormatter = (value) => { return value }, handleEnterKeyPress = (event) => { return false }, allowCross = false, tipFormatter = null, ...restRangeProps}) => {

    const handleKeyPress = (event) => {
        if ( event.key.toLowerCase() === 'enter' ) {
            handleEnterKeyPress(event);
        }
    };

    const handleRender = (node, props) => {
        return cloneElement(
            node,
            {onKeyPress: ( (event) => handleKeyPress(event) )}
        );
    }

    return (
        <Slider
            range
            {...restRangeProps}
            handleRender={handleRender}
            ariaValueTextFormatterForHandle={(value) => handleFormatter(value)}
        />
    );
};

SliderRange.propTypes = {
    handleFormatter: PropTypes.func,
    handleEnterKeyPress: PropTypes.func
};

export default SliderRange;
